var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 142,
    height: 142,
    viewBox: "0 0 142 142",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_745_987)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 6,
    width: 336,
    height: 169,
    rx: 84.5,
    fill: "#9BE282",
    fillOpacity: 0.3
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_745_987"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 142,
    height: 142,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreen);
export default __webpack_public_path__ + "static/media/green.a210ba9f44e4481ba2653a759f88b31e.svg";
export { ForwardRef as ReactComponent };